import './chart.style.less'

import MainWrapper from './MainWrapper'
import { Pie } from 'react-chartjs-2'

interface props {
  title: string
  sign?: string
  showLegend?: boolean
  data?: any
  labelStyle?: any
  datalabels?: any
  id: string
  periods?: string[]
  onPeriodChange?: (period: string) => any
}

function PieChart(props: props) {
  const {
    data,
    showLegend = true,
    title,
    sign = '',
    id,
    periods = [],
    onPeriodChange = (period) => {},
    labelStyle,
  } = props
  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        formatter: (val) => {
          return val > 0.1 ? val + sign : ''
        },
        labels: labelStyle,
      },
    },
    legend: {
      display: showLegend,
      labels: {
        usePointStyle: true,
        pointStyle: 'rect',
      },
    },
  }
  return (
    <MainWrapper
      id={id}
      title={title}
      onPeriodChange={onPeriodChange}
      periods={periods}
    >
      <Pie data={data} options={options} />
    </MainWrapper>
  )
}
export default PieChart
